import { NgModule } from '@angular/core';
import { GridRightClickMenuComponent } from './grid-right-click-menu.component';
import { GridRightClickMenuDirective } from './grid-right-click-menu.directive';

/**
 * A module that provides right-click context menu functionality for Kendo Grid components.
 * 
 * This module imports and exports both the GridRightClickMenuDirective that attaches to Kendo Grid
 * components and the GridRightClickMenuComponent that renders the context menu UI. Using this
 * module enables filtering operations via right-click on grid cells.
 * 
 * @example
 * ```typescript
 * // In your app module
 * import { GridRightClickMenuModule } from '@ticomix/angular-kendo';
 * 
 * @NgModule({
 *   imports: [
 *     GridRightClickMenuModule
 *   ]
 * })
 * export class AppModule { }
 * ```
 * 
 * ```html
 * <!-- In your component template -->
 * <kendo-grid [data]="gridData"></kendo-grid>
 * <app-grid-context-menu></app-grid-context-menu>
 * ```
 */
@NgModule({
  declarations: [
    // Add your components here
  ],
  imports: [GridRightClickMenuComponent, GridRightClickMenuDirective],
  exports: [
    // Add your components or modules that you want to export here
    GridRightClickMenuDirective,
    GridRightClickMenuComponent,
  ],
})
export class GridRightClickMenuModule {}
